import { render, staticRenderFns } from "./user-assignee-dropdown.vue?vue&type=template&id=82cdd59c"
import script from "./user-assignee-dropdown.vue?vue&type=script&lang=js"
export * from "./user-assignee-dropdown.vue?vue&type=script&lang=js"
import style0 from "./user-assignee-dropdown.vue?vue&type=style&index=0&id=82cdd59c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports